import type { PersonContextRecord } from '../../store/api/apiSlice';
import { rpcSlice } from '../../store/api/rpcSlice';

export const personContextApi = rpcSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPersonContext: builder.query<PersonContextRecord, { personId: string }>({
      query: ({ personId }) => ({
        url: '/person_context.get',
        params: { person_id: personId },
      }),
      providesTags: (_result, _error, arg) => [{ type: 'PersonContext', id: arg.personId }],
    }),
    upsertPersonContext: builder.mutation<
      PersonContextRecord,
      { personId: string; context: string }
    >({
      query: ({ personId, context }) => ({
        url: '/person_context.upsert',
        method: 'POST',
        body: { person_id: personId, context },
      }),
      invalidatesTags: (_result, _error, arg) => [{ type: 'PersonContext', id: arg.personId }],
      async onQueryStarted({ personId, context }, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(
            personContextApi.util.updateQueryData('getPersonContext', { personId }, () => ({
              person_id: personId,
              context,
              created_at: data.created_at,
              updated_at: data.updated_at,
            }))
          );
        } catch {}
      },
    }),
  }),
  overrideExisting: true,
});

export const { useGetPersonContextQuery, useUpsertPersonContextMutation } = personContextApi;
